/**
 * Admin → Export locations (0.95.0, before on the Storage tab): the destinations people can pick when they
 * export a sequence. The exports *tier* (where an export goes when none is picked) stays on Storage.
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Send } from 'lucide-react';
import { useStorage } from '../../api/hooks';
import { AddLocationDialog } from './storage/AddLocationDialog';
import { LocationCard } from './storage/LocationCard';

export function ExportLocationsAdmin() {
  const q = useStorage();
  const items = q.data?.items ?? [];
  const exportsTo = items.filter((l) => l.purpose === 'export');
  const [adding, setAdding] = useState(false);
  const tier = items.find((l) => l.id === q.data?.policy?.exportsLocationId);
  return (
    <div className="page" data-testid="export-locations-admin">
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
        <h2 style={{ margin: 0 }}>Export locations</h2>
        <span style={{ flex: 1 }} />
        <button className="btn" onClick={() => setAdding(true)} data-testid="add-export-location"><Send size={14} /> Add export location</button>
      </div>
      <p className="lede">
        Destinations people can pick when they export a sequence: server folders, S3 and OCI buckets, and folders on storage agents, which
        receive a copy once the export has rendered. An export with no location chosen goes to the exports tier
        {tier ? <> (now <strong>{tier.name}</strong>)</> : null}, set on <Link to="/admin/storage">Storage</Link>.
      </p>
      {q.isLoading ? <div className="skeleton" style={{ height: 160 }} /> : (
        <div className="cards" data-testid="export-locations">
          {exportsTo.map((l) => <LocationCard key={l.id} loc={l} all={items} />)}
          {exportsTo.length === 0 && <p className="muted">No export locations yet; exports go to the exports tier.</p>}
        </div>
      )}
      {adding && <AddLocationDialog purpose="export" onClose={() => setAdding(false)} />}
    </div>
  );
}
